import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Opts } from "@ofqual/portal-core/core/types";
import { ConflictResponse } from "../domain/ConflictResponse";

export type PeRequiredItem = {
  id: string;
  category: number;
  learnerType: number;
  exceptionCircumstances: number;
  customerTypeId: number;
  directorate: number;
  summary: string;
};

export class PeService extends BaseRemoteService {
  public async createPe(
    foiId: string,
    peRequiredItem: PeRequiredItem,
    opts: Opts
  ): Promise<ConflictResponse> {
    const url = `${this.apiRoot}/publicenquiries/${foiId}/createfromfoi`;
    try {
      const response = await super.postRequest<any>(url, peRequiredItem, opts);
      return { data: response, status: 204, error: null };
    } catch (e: any) {
      if (e.status === 409) {
        return { data: e.message, status: e.status, error: e.error };
      } else {
        throw e;
      }
    }
  }

  public async getPeFromFoiId(id: string, opts: Opts): Promise<any> {
    const url = `${this.apiRoot}/publicenquiries/${id}/peforfoi`;
    try {
      const response = await super.getRequest<any>(url, opts);
      return { data: response, status: 204, error: null };
    } catch (e: any) {
      if (e.status === 404) {
        return { data: e.message, status: e.status, error: e.error };
      }
    }
  }

  public async getPe(id: string, opts: Opts): Promise<any> {
    const url = `${this.apiRoot}/publicenquiries/${id}`;
    const response = await super.getRequest<any>(url, opts);
    return response;
  }
}
